import React from "react";
import { useEffect, useState } from "react";
import * as Survey from "survey-react";
import "survey-react/survey.css";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT } from "../../Constants";
import { Spinner, Button } from "reactstrap";
import { updateConsultationDetails } from "../../services/Api";
import {  getList,postList,genericPost,genericGet } from "../../services/Api";
import { ENDPOINTS } from "../../Constants";
import moment from "moment";
import { JsonToTable } from "react-json-to-table";

import { useHistory } from "react-router-dom";

const ConsultationForm = (props) => {
  const history = useHistory();
  const { patient_info, room } = (props.location && props.location.state) || {};
  const [template, settemplate] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  const [started, setSaterted] = useState();
  const [patient_history, setPatientHistory] = useState();
  
var dd=
     [
        {
            "id": "a6992096-8eeb-47d2-9d0a-168e6bded79e",
            "visit_count": 1,
            "status": 10000,
            "started_at": "2025-05-12 14:16:20",
            "ended_at": "2025-05-12 14:18:17",
            "created_by": 845,
            "serviced_by": null,
            "hospital_id": "718bfbb3-4602-11ef-b416-0a9ea65235cc",
            "from_room_id": "03c37556-4606-11ef-b416-0a9ea65235cc",
            "to_room_id": "82f33741-4606-11ef-b416-0a9ea65235cc",
            "parent_id": "dadfcee3-0ff0-4169-8c08-bd9747fce615",
            "created_at": "2025-05-12 11:18:18",
            "updated_at": "2025-05-12 11:18:18",
            "visit_info": {
                "age": "22",
                "name": "Musa Hixi Test 001",
                "gender": "male",
                "village": "Village test001",
                "criteria": {
                    "score": 60,
                    "farmers": "2",
                    "migrants": "3",
                    "minority": "3",
                    "School_age": "3",
                    "canProceed": true,
                    "under_five": "5",
                    "adolescents": "3",
                    "influencers": "1",
                    "child_headed": "5",
                    "double_orphan": "5",
                    "female_headed": "5",
                    "socioeconomic": "5",
                    "pregnant_woman": "5",
                    "more_under_five": "5",
                    "lactating_mother": "5",
                    "elderly_individuals": "2",
                    "people_with_disabilities": "3"
                },
                "district": "Test District",
                "service_type": [
                    "nutrition_services"
                ],
                "contact_telephone": "623851943",
                "nutrition_services": {
                    "muac": "11.5",
                    "additional_nutrition_info": null
                },
                "health_care_services": null
            }


            ,
            "patient_id": "dadfcee3-0ff0-4169-8c08-bd9747fce615",
            "labs": [
                {
                    "id": "b2c6771f-73a4-4244-b0c7-a3667d2ccb27",
                    "visit_id": "a6992096-8eeb-47d2-9d0a-168e6bded79e",
                    "from_room_id": "82f33741-4606-11ef-b416-0a9ea65235cc",
                    "room_id": "65372a94-4606-11ef-b416-0a9ea65235cc",
                    "status": 10002,
                    "started_at": null,
                    "ended_at": null,
                    "lab_request": {
                        "lab": [
                            {
                                "remarks": "Conduct the following\nDipstick test\nMicroscopic examination\nSpecific gravity test",
                                "lab_test": "ff7adfa8-9511-11ef-a197-0a9ea65235cc"
                            },
                            {
                                "remarks": "Conduct the following:\nWhite Blood Cell (WBC) count\nHemoglobin (Hb) and Hematocrit (Hct)\nPlatelet count",
                                "lab_test": "ff7adfa8-9511-11ef-a197-0a9ea65235ff"
                            }
                        ]
                    },
                    "lab_result": {
                        "ph": "test",
                        "rbc": "test",
                        "wbc": "test",
                        "cast": "test",
                        "Blood": "test",
                        "color": "test",
                        "ketone": "test",
                        "others": "test",
                        "crystal": "test",
                        "glucose": "test",
                        "nitrate": "test",
                        "protein": "test",
                        "parasite": "test",
                        "bilirubin": "test",
                        "s_gravity": "test",
                        "appearance": "test",
                        "leucocytes": "test",
                        "urobilinogen": "test",
                        "epithelial_cells": "test",
                        "infecting_organism": "test",
                        "ff7adfa8-9511-11ef-a197-0a9ea65235ff": "Positive"
                    },
                    "created_by": 180,
                    "serviced_by": 180,
                    "created_at": "2025-05-12 11:48:04",
                    "updated_at": "2025-05-12 11:52:13"
                }
            ],
            "consultations": [
                {
                     
                        "diagnosis": "Likely Coronary artery disease (CAD), pending further investigation (e.g., ECG, cardiac enzymes, stress test)",
                        "doctor_assessment": "Assessment shows some blockage at the chest.",
                        "patient_complains": "Complained to have chest pain",
                        "differential_diagnosis": "Angina pectoris\nAcute coronary syndrome (ACS)\nMyocardial infarction (MI)\nGastroesophageal reflux disease (GERD)\nCostochondritis\nPulmonary embolism",
                        "created_by":"Dr XXX"
                   
                }
            ],
            "prescriptions": [
                {
                    "id": "e251b546-d5cc-4c04-b8fd-551087a5ca40",
                    "visit_id": "a6992096-8eeb-47d2-9d0a-168e6bded79e",
                    "from_room_id": "82f33741-4606-11ef-b416-0a9ea65235cc",
                    "room_id": "5329d1fe-81f1-11ec-81e5-0a9ea65235cc",
                    "status": 10000,
                    "started_at": "2025-05-12 14:49:35",
                    "ended_at": null,
                    "prescription_request": {
                        "prescription_form": [
                            {
                                "drug": "0f6faf01-c3c6-4e7e-8e3d-1bd6faacdaeb",
                                "name": "Drug Vitamin C syrup 100ml",
                                "remarks": "Before Meals",
                                "uom_name": "Pcs",
                                "mode_of_application": "1X2"
                            },
                            {
                                "drug": "7dae088e-db94-4d46-a8ee-c42194c33364",
                                "name": "Paracetamol syrup 250mg\/5ml 100 ml,",
                                "remarks": "After meals",
                                "uom_name": "Pcs",
                                "mode_of_application": "1X3"
                            }
                        ]
                    },
                    "prescription_serviced": null,
                    "created_by": 180,
                    "serviced_by": null,
                    "created_at": "2025-05-12 11:49:35",
                    "updated_at": "2025-05-12 11:49:35",
                    "voucher": "03888655",
                    "doctor": {
                        "id": 180,
                        "name": "Moses Njagua"
                    }
                }
         ],
         "dd":1
        }
        ];
    
      



  const [to_room_id, setTo_room_id] = useState("");
  useEffect(() => {
    settemplate(room.template);
    setSaterted(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
    getPatientHistory();
    return () => {};
  }, []);

  function parseData(str) {
    var rs=null;
    try {
      rs= JSON.stringify(str);
    
      return str;
      
    } catch (e) {
      alert(e)
        return str;
    }
    return str;
}

  const _submit = (form_result) => {
    console.log(form_result.valuesHash);

    let payload = {
      service_request_id: patient_info.service_request_id,
      consultation_details: form_result.valuesHash,
      started_at: started,
      ended_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    console.clear();
    console.log(payload);

    setIsloading(true);
    updateConsultationDetails(payload)
      .then((res) => {
        setIsloading(false);
        var response = res.data;

        console.log(res);
        if (res.status == 200) {
          if (response.status == SUCCESS_RESULT) {
            console.log(response);
            cogoToast.success("Consultation details updated Successfully", {
              hideAfter: 5,
            });

            //   history.push({
            //     pathname: "/hmis/print-visit",
            //     state: {
            //       visit: response.data,

            //     },
            //   });
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };
  const getPatientHistory = () => {
 
    setIsloading(true);
  genericPost(ENDPOINTS.PATIENT_HISTORY, {
    "patient_id":patient_info?.patient_id
    })
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            setPatientHistory(res.data["data"]);
         
          } else {
            cogoToast.error(res.data.message, {});
          }
        } else {
          cogoToast.error("Connection error. Please try again.", {});
        }
        setIsloading(false);
      })
      .catch((err) => {
        // log("Error:: ");
        // log(err);
        setIsloading(false);
        cogoToast.error("Critical error occurred. Please try again.", {});
      });
  };


    const renderTable = (json) => {
    try {
      
     var x=JSON.stringify(json);
     if(x!="{}" && x!="[]" && x!="" && x!="undefined" && x!=null && x!="[null]" && x!="null" && x!="undefined" && x!="{}" && x!="[]" && x!="" && x!="undefined" && x!=null && x!="[null]"){
       
       return <JsonToTable json={json} />;}
      else{return <> No Data </> }
    } catch (error) {

 
      console.error("Error rendering JsonToTable:", error);
      return <p>....</p>;
    }
  };
  return (
    <>
      <div className="row">
         {/* {JSON.stringify(room)}
         <hr/>  
        {JSON.stringify(patient_info)} */}
        <hr/>
       
{/* {JSON.stringify(patient_history[0]?.consultations)}
{JSON.stringify(patient_history[0])} */}


        <div className="col-md-8">
          <h1 className="alert alert-primary">
            Consultation    ➤      {patient_info.name}
            
          </h1>

          <div className="d-flex justify-content-center my-1">
            {Isloading && <Spinner />}
          </div>



   Previous Visits <br/>
          <div className="card">
              <div className="card-body">
                <div className="accordion" id="">
               
               
               {patient_history?.map((h)=>{

return  <div className="accordion-item">

 

<h2 className="accordion-header" id="heading-1">
  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="false">
    Visit  # <b>  {h.visit_count}  </b> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;   &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Date :   &nbsp; &nbsp; <b>  {moment(h.started_at).format("YYYY-MM-DD HH:mm:ss")} </b> 
  </button>
</h2>
<div id="collapse-1" className="accordion-collapse collapse" style={{backgroundColor:"#fff"}} data-bs-parent={"#"+h.id} >
 

<div className="accordion-body pt-0">
    <strong>Consultations</strong> 
    <br/>
{/* {JSON.stringify(patient_history[0]?.consultations)} */}

    {/* {h?.consultations} */}
    {/* <JsonToTable json={JSON.parse(h?.consultations)} /> */}

    </div>
  <div className="accordion-body pt-0">
  
 
    <h1> ➤  Visit Info</h1>
    {renderTable(h?.visit_info)}
    {/* <JsonToTable json={ /> */}

    
    <h1> ➤  Consultations</h1>
    {/* <JsonToTable json={h?.consultations} /> */}
    {renderTable(h?.consultations)}


    <h1> ➤ Prescriptions</h1>
    {/* <JsonToTable json={h?.prescriptions[0]?.prescription_request} /> */}
    {renderTable(h?.prescriptions[0]?.prescription_request)}

        <h1> ➤ Lab Results</h1>
 
        {h?.labs?.map((l)=>{

          try{
            if(l?.lab_result==""){
              return <></>
            }
            return <> <br/>
              <JsonToTable json={ l?.lab_result} />  </>
              

      
          }catch(e){
            return <i>    </i>
          }
        }
        )}

{/* <JsonToTable json={h} /> */}


    
    <hr/>


    {/* <JsonToTable json={parseData(h?.labs)} /> */}
{/* {JSON.stringify(h?.labs)}
 */}

{/* 
 {h?.labs?.map((l)=>{
  try{
    if(l?.lab_result==""){
      return <></>
    }
    return <><h3>LAB RESULTS</h3> <br/>  <JsonToTable json={JSON.parse(l?.lab_result)} />  </>

  //  var j= json.parse(l.lab_request.replaceAll("\\\\",""));
    // return <b>{JSON.stringify(j)}</b>;
  }catch(e){
    return <i>    </i>
  }
 })}
     */}

    {/* <strong>consultations</strong> 
    <br/>
    
  {JSON.stringify( h?.consultations)}
    <hr/> */}
    {/* <strong>Consultation Details</strong> 
    <br/> */}
{/*     
    <JsonToTable json={h?.consultations[0]?.consultation_details} /> */}
    <hr/>

    
  </div>
</div>
</div>

               })}
                 
                 
                </div>
              </div>
            </div>

{/* {dd?.map((h)=>{

  return <div className="alert alert-primary">
    <h3>Patient Info</h3>
    <JsonToTable json={h.visit_info} />
    <hr/>
    <h3>Consultation Details</h3>
    <JsonToTable json={h.consultations[0]} />
  </div>
})
} */}





        
        </div>

        <div className="col-md-4">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Actions</h3>
            </div>
            <div className="list-group list-group-flush">
              <span
                className="list-group-item list-group-item-action"
                aria-current="true"
                onClick={(e) => {
                  history.push({
                    pathname: "/hmis/request-lab-test",
                    state: {
                      patient_info: patient_info,
                      room: room,
                    },
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <line x1="15" y1="16" x2="19" y2="12"></line>
                  <line x1="15" y1="8" x2="19" y2="12"></line>
                </svg>{" "}
                &nbsp; LAB TEST REQUEST
              </span>
              <span
                className="list-group-item list-group-item-action"
                aria-current="true"
                onClick={(e) => {
                  history.push({
                    pathname: "/hmis/add-prescriptions",
                    state: {
                      patient_info: patient_info,
                      room: room,
                    },
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <line x1="15" y1="16" x2="19" y2="12"></line>
                  <line x1="15" y1="8" x2="19" y2="12"></line>
                </svg>{" "}
                &nbsp; MEDICAL PRESCRIPTION
              </span>
            </div>
          </div>
        <hr/>


<h2>Create consultation details</h2>
  {template != null && (
            <Survey.Survey
              json={template}
              onComplete={(data) => _submit(data)}
            />
          )}
          {template == null && (
            <div className="alert alert-danger" role="alert">
              No consultation Template available for <b> {room.room_name}</b>
            </div>
          )}

   
        
        </div>
      </div>
    </>
  );
};

export default ConsultationForm;
